import React from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import { slide as Menu } from "react-burger-menu";

import { useMenuData } from "../../lib/hooks";
import { useDrupalSettings } from "../../lib/DrupalSettings";

import NavMenuLevel from "../NavMenuLevel";
import IcomoonIcon from "../IcomoonIcon";
import css from "./NavMenu.module.scss";

/* eslint-disable react/forbid-prop-types */

const HOMEPAGE_TITLE = "Gallery guides and podcasts";
const SUBPAGE_TITLE = "Gallery guides";

const NavMenuTitle = ({ location, themeConfig, limitGuide = null }) => {
  const interior = (
    <>
      {location.pathname === "/" && limitGuide === null && HOMEPAGE_TITLE}
      {(location.pathname !== "/" || limitGuide !== null) && SUBPAGE_TITLE}
    </>
  );

  return (
    <p className={css.appHeaderTitle}>
      {themeConfig.homePage === 1 && <Link to="/">{interior}</Link>}
      {themeConfig.homePage !== 1 && <a href="/">{interior}</a>}
    </p>
  );
};

NavMenuTitle.propTypes = {
  location: PropTypes.any.isRequired,
  themeConfig: PropTypes.any.isRequired,
  limitGuide: PropTypes.number
};

NavMenuTitle.defaultProps = {
  limitGuide: null
};

const NavMenu = ({
  className = "",
  menuPadding = false,
  limitGuide = null
}) => {
  const { state: drupalSettings } = useDrupalSettings();
  const location = useLocation();
  const menuTree = useMenuData();
  const [isOpen, setIsOpen] = React.useState(false);
  const menuStyles = {
    bmBurgerButton: {
      boxSizing: "border-box",
      position: "fixed",
      width: "6em",
      height: "65px",
      right: "0px",
      background: "#000",
      color: "#fff",
      padding: "0.5rem 1.5rem"
    },
    bmBurgerBars: {
      background: "#fff"
    },
    bmBurgerBarsHover: {
      background: "#000000"
    },
    bmCrossButton: {
      height: "24px",
      width: "24px"
    },
    bmCross: {
      background: "#bdc3c7"
    },
    bmMenuWrap: {
      position: "fixed",
      height: "100%",
      width: "370px"
    },
    bmMenu: {
      background: "#000",
      padding: "2.5em 1.5em 0",
      margin: "0",
      fontSize: "1.15em"
    },
    bmMorphShape: {
      fill: "#373a47"
    },
    bmItemList: {
      color: "#fff",
      height: "calc(100% - 1em)",
      padding: "0em",
      margin: "0"
    },
    bmItem: {
      display: "inline-block"
    },
    bmOverlay: {
      background: "rgba(0, 0, 0, 0.3)"
    }
  };

  const themeConfig = drupalSettings.slnswAudioGuideTheme || {
    homePage: 1,
    audioGuideNids: []
  };

  // Function to close menu after clicking.
  const closeMenu = e => {
    setTimeout(() => setIsOpen(false), 100);
    return true;
  };

  return (
    <header
      className={[
        css.app_header,
        className || "",
        menuPadding ? css.app_header_padded : ""
      ].join(" ")}
    >
      <a
        className={css.appHeaderLogo}
        href="https://www.sl.nsw.gov.au"
        title="State Library of NSW website"
        tabIndex="0"
      >
        <img
          src="/themes/custom/slnsw_audio_guide_theme/slnsw-logo-icon.black.svg"
          alt="State Library of NSW logo"
          className={css.logo_link}
        />
      </a>

      <NavMenuTitle
        location={location}
        themeConfig={themeConfig}
        limitGuide={limitGuide}
      />

      {limitGuide === null && (
        <Menu
          styles={menuStyles}
          customBurgerIcon={<IcomoonIcon iconName="menu" />}
          burgerButtonClassName={css.menu_burger_icon}
          isOpen={isOpen}
          onOpen={() => setIsOpen(true)}
          onClose={() => setIsOpen(false)}
          right
        >
          <NavMenuLevel
            items={menuTree}
            drupalSettings={drupalSettings}
            closeMenu={closeMenu}
          />
        </Menu>
      )}
    </header>
  );
};

NavMenu.propTypes = {
  className: PropTypes.string,
  menuPadding: PropTypes.bool,
  limitGuide: PropTypes.number
};

NavMenu.defaultProps = {
  className: "",
  menuPadding: false,
  limitGuide: null
};

export default NavMenu;
